import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string,
};

const Email = ({
  width, height, fill, stroke,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <circle cx={15} cy={15} r={15} fill={fill} />
    <path
      d="M22.295 19.25l-3.775-3.702-.522.474 3.82 3.746H8.188l3.82-3.745-.522-.475L7.71 19.25v-8.089l3.831 3.484.441.401.008.007.521.475h.001l.647.59 1.611 1.467a.36.36 0 00.464 0l1.61-1.466.648-.591h.001l1.106-1.007 3.695-3.36v8.09l.001-.001zm.219-9.242c.27.023.492.246.492.515v9.42a.535.535 0 01-.533.523H7.533A.535.535 0 017 19.943v-9.42a.53.53 0 01.492-.515l.761.692 6.75 6.147 6.75-6.147.761-.692zM21.478 10l-.767.698H9.295L8.53 10h12.949-.001z"
      fill={stroke}
    />
  </svg>
);

Email.propTypes = iconPropTypes;

Email.defaultProps = {
  width: 30,
  height: 30,
  stroke: '#fff',
  fill: '#624df3',
};

const Facebook = ({
  width, height, fill, stroke,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <circle cx={15} cy={15} r={15} fill={fill} />
    <path
      d="M11.986 24.381h4.416v-9.386h2.609s.244-1.515.363-3.171h-2.957v-2.16c0-.323.424-.757.843-.757h2.118V5.62h-2.88c-4.08 0-3.983 3.161-3.983 3.634v2.583h-1.893v3.159h1.893v7.299"
      fill="none"
      stroke={stroke}
    />
  </svg>
);

Facebook.propTypes = iconPropTypes;

Facebook.defaultProps = {
  width: 30,
  height: 30,
  stroke: '#fff',
  fill: '#0e1f56',
};

const Instagram = ({
  width, height, fill, stroke,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <circle cx={15} cy={15} r={15} fill={fill} />
    <path
      d="M20.431 8L22 9.569V20.43L20.431 22H9.57L8 20.431V13.25h5.036l-.384.658c-.206.353-.255.57-.255 1.092a2.602 2.602 0 102.701-2.601L15 12.397v-.875A3.478 3.478 0 1111.522 15c0-.31.018-.557.067-.781l.022-.094H8.875v5.943l1.056 1.057h10.137l1.057-1.056V9.93l-1.057-1.056H9.931L8.875 9.93v2.007H8v-2.37L9.569 8h10.862zm-1.275 1.313a1.531 1.531 0 11.002 3.062 1.531 1.531 0 01-.002-3.062zm0 .875a.656.656 0 100 1.311.656.656 0 000-1.311z"
      fill={stroke}
      fillRule="nonzero"
    />
  </svg>
);

Instagram.propTypes = iconPropTypes;

Instagram.defaultProps = {
  width: 30,
  height: 30,
  stroke: '#fff',
  fill: '#ff514e',
};

const Twitter = ({
  width, height, fill, stroke,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <circle cx={15} cy={15} r={15} fill={fill} />
    <path
      d="M21.417 10.326a3.457 3.457 0 001.517-1.909 6.913 6.913 0 01-2.191.838 3.445 3.445 0 00-2.52-1.09c-2.227 0-3.865 2.079-3.362 4.237A9.797 9.797 0 017.75 8.796a3.456 3.456 0 001.067 4.608 3.436 3.436 0 01-1.562-.432c-.038 1.6 1.108 3.095 2.768 3.428a3.46 3.46 0 01-1.559.059 3.454 3.454 0 003.224 2.396 6.939 6.939 0 01-5.11 1.43 9.77 9.77 0 005.291 1.55c6.408 0 10.028-5.411 9.809-10.265"
      fill="none"
      stroke={stroke}
    />
  </svg>
);

Twitter.propTypes = iconPropTypes;

Twitter.defaultProps = {
  width: 30,
  height: 30,
  stroke: '#fff',
  fill: '#55acee',
};

const WhatsApp = ({
  width, height, fill, stroke,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <circle cx={15} cy={15} r={15} fill={fill} />
    <path
      d="M8.78 9.529l.708.702a6.825 6.825 0 00-1.636 4.435 6.82 6.82 0 001.326 4.046l-.87 2.563 2.676-.85a6.962 6.962 0 003.83 1.142 6.97 6.97 0 004.475-1.622l.707.702a7.956 7.956 0 01-5.182 1.913 8.04 8.04 0 01-3.85-.982l-.15-.082-4.042 1.282 1.316-3.88-.095-.156a7.826 7.826 0 01-1.143-4.076 7.81 7.81 0 011.93-5.137zm6.034-2.757c4.392 0 7.964 3.54 7.964 7.894a7.82 7.82 0 01-2.072 5.292l-.708-.702a6.83 6.83 0 001.779-4.59c0-3.805-3.124-6.902-6.963-6.902a6.96 6.96 0 00-4.631 1.763l-.708-.702a7.963 7.963 0 015.339-2.053zm-2.784 3.837c.142.006.284.029.409.033.124.005.305-.059.467.371.161.43.548 1.488.598 1.596.05.107.08.232.004.37-.077.14-.116.226-.227.346l-.228.251-.106.107c-.11.102-.226.212-.11.428.117.217.519.926 1.132 1.51.789.751 1.468 1 1.677 1.114.21.114.335.101.465-.036.13-.136.557-.598.707-.804.151-.207.292-.166.485-.088.193.077 1.222.628 1.432.743.21.113.35.171.4.261.05.091.034.515-.162 1.002-.197.487-1.087.932-1.48.952a.919.919 0 00-.146.02l-.07.014c-.271.052-.63.078-2.326-.658-2.137-.928-3.424-3.185-3.525-3.33-.102-.145-.829-1.18-.789-2.22a2.315 2.315 0 01.715-1.64l.099-.098a.791.791 0 01.579-.244z"
      fill={stroke}
    />
  </svg>
);

WhatsApp.propTypes = iconPropTypes;

WhatsApp.defaultProps = {
  width: 30,
  height: 30,
  stroke: '#fff',
  fill: '#25d366',
};

export {
  Email,
  Facebook,
  Instagram,
  Twitter,
  WhatsApp,
};
